import React from 'react'
import styled from 'styled-components'
import facebook from '../../assets/images/fb.svg'
import github from '../../assets/images/github.svg'
import instagram from '../../assets/images/instagram.svg'
import gmail from '../../assets/images/gmail.svg'
import linkedin from '../../assets/images/in.svg'
import  { Button } from '../../globalStyle'
import { url } from '../../App'



const WrappFooter = styled('div')`
    width:100%;
    display:flex;
    padding:30px 80px;
    z-index:99999;
    margin-top:-130px;
    position:relative;
    background:#4a55da;
    justify-content: space-between;
    @media screen and ( max-width: 1200px){
        padding:30px 30px;
        margin-top:-100px;
    }
    @media screen and ( max-width: 990px){
        margin-top:-70px;
    }
    @media screen and ( max-width: 830px){
        flex-direction:column-reverse;
        margin-top:-20px;
        justify-content:center;
        padding:30px 30px;
    }`

const WrappCopyright = styled('div')`
    display:flex;
    padding:0;
    flex-direction:column;
    color: #fff;
    @media screen and ( max-width: 900px){
        align-items:center;
    }`

const JudulFooter = styled.p`
    font-size:20px;
    margin-bottom:10px;
    font-weight:700;
    color:#fff;
`
const MenuFooter = styled('p')`
    font-size:16px;
    color:#fff;
    /* border-bottom:1px solid #fff; */
    font-weight:500;
    &:hover{
        opacity:.8;
    }
`
const TextCopyright = styled('p')`
    font-size:16px;
    color:#fff;
    font-weight:600;
`

const A = styled('a')`
    text-decoration:none;
    color:#fff;
    cursor:pointer;
    &:hover{
        text-decoration:underline;
    }
`

const Img = styled.img`
    height:30px;
    width:30px;
    transition: .7s ease;
    &:hover{
        transform: scale(1.2);
    }
`
const WrappMenu = styled('div')`
    display:grid;
    align-items:center;
    grid-template-columns:auto auto auto auto auto;
    grid-gap:10px;
    justify-content:space-between;
`
const Row = styled('div')`
    display:flex;
    flex-direction:column;
    align-items:center;
    @media screen and ( max-width: 900px){
        margin-bottom:30px;
    }
`
const Margin = styled.div`
    margin-bottom:380px;
    display:flex;
    position:relative;
`
function Footer(){
    return(
        <>
         {/* <Margin /> */}
            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#4a55da" fillOpacity="1" d="M0,160L34.3,165.3C68.6,171,137,181,206,176C274.3,171,343,149,411,128C480,107,549,85,617,101.3C685.7,117,754,171,823,165.3C891.4,160,960,96,1029,96C1097.1,96,1166,160,1234,176C1302.9,192,1371,160,1406,144L1440,128L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z"></path></svg>
        <WrappFooter>
                <WrappCopyright>
                    <A href="#" > <Button margin>Download CV</Button>
                    </A>
                    <TextCopyright> &copy; Adam Dwi Maulana, Bekasi Indonesia  </TextCopyright>
                </WrappCopyright>
                <Row>
                    <JudulFooter>Menu</JudulFooter>
                    <WrappMenu>
                        <A href='/#projects'>
                            <MenuFooter>Projects</MenuFooter>
                        </A>
                        <A href='/#skill'> 
                            <MenuFooter>Skills</MenuFooter>
                        </A>
                        <A href='/#certificates'>
                            <MenuFooter>Certificates</MenuFooter>
                        </A>
                    </WrappMenu>
                </Row>
                <Row>
                    <JudulFooter>Contact Me</JudulFooter>
                    <WrappMenu>
                        <A href="https://www.facebook.com/adamdwi.maulana.35/" target="_blank" rel="noreferer">
                            <Img src={facebook} />
                        </A>
                        <A href="https://github.com/adam-webdev" target="_blank" rel="noreferer">
                            <Img src={github} />
                        </A>
                        <A href="https://www.instagram.com/adam_webdev/" target="_blank" rel="noreferer">
                            <Img src={instagram} />
                        </A>
                        <A href="https://www.linkedin.com/in/adam-dwi-maulana-8a5a9214a/" target="_blank" rel="noreferer">
                            <Img src={linkedin} />
                        </A>
                      
                    </WrappMenu>
                </Row>
                </WrappFooter>
            </>
    )
}
export default Footer